// GoogleMapsProvider.js
import React from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { GoogleMapsAPIKey } from '../firebaseConfig';

export const GoogleMapsContext = React.createContext({ isLoaded: false });

const libraries = ['geometry', 'places'];

const GoogleMapsProvider = ({ children }) => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-maps',
        googleMapsApiKey: GoogleMapsAPIKey,
        libraries,
        version: 'weekly',
    });

    return (
        <GoogleMapsContext.Provider value={{ isLoaded }}>
            {children}
        </GoogleMapsContext.Provider>
    );
};

export default GoogleMapsProvider;